'use client';

/**
 * Utility hook to check if popups are enabled.
 * - Always returns true in client-side environments (staging/production/development)
 * - Returns false on server-side rendering
 */
function useGlobalDialogsEnabled(): boolean {
  // Only enable popups in client-side environment
  return typeof window !== 'undefined';
}

export { useGlobalDialogsEnabled };
